import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { guestbookAPI, settingsAPI } from '../services/api';
import { getCoordinatesFromLocation } from '../utils/geocoding';

const GuestbookForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    message: '',
    image: null
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const data = await settingsAPI.getSettings();
      setSettings(data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      setSettings({
        form_title: "📝 Firma nuestro libro de visitas",
        form_subtitle: "Déjanos tu mensaje de celebración",
        form_note: "* Tu mensaje será revisado antes de aparecer en el mapa"
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error('La imagen no puede superar 5MB');
        return;
      }
      setFormData(prev => ({ ...prev, image: file }));
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.location || !formData.message) {
      toast.error('Por favor, completa todos los campos obligatorios');
      return;
    }

    setIsSubmitting(true);

    try {
      // Create entry (no image)
      const entryData = {
        name: formData.name,
        location: formData.location,
        message: formData.message,
        image: null,
        coordinates: getCoordinatesFromLocation(formData.location)
      };

      await guestbookAPI.createEntry(entryData);
      
      // Reset form
      setFormData({
        name: '',
        location: '',
        message: '',
        image: null
      });
      setImagePreview(null);
      
      toast.success('Gracias por participar. ¡Un abrazo de todo el equipo Enfusión!');
      
      if (onSubmit) {
        onSubmit();
      }
    } catch (error) {
      console.error('Error submitting entry:', error);
      toast.error('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!settings) {
    return <div style={{ padding: '2rem', textAlign: 'center', color: '#56cea4' }}>Cargando...</div>;
  }

  return (
    <div className="guestbook-form-container">
      <div className="form-header">
        <h2 className="form-title">{settings.form_title}</h2>
        <p className="form-subtitle">{settings.form_subtitle}</p>
      </div>
      
      <form onSubmit={handleSubmit} className="guestbook-form">
        <div className="form-group">
          <Label htmlFor="name">Tu nombre *</Label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ej: María García"
            required
            disabled={isSubmitting}
            className="retro-input"
          />
        </div>

        <div className="form-group">
          <Label htmlFor="location">Tu ubicación *</Label>
          <Input
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="Ej: Madrid, España"
            required
            disabled={isSubmitting}
            className="retro-input"
          />
        </div>

        <div className="form-group">
          <Label htmlFor="message">Tu mensaje *</Label>
          <Textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Comparte tus recuerdos, felicitaciones o historias sobre Enfusión..."
            required
            disabled={isSubmitting}
            className="retro-textarea"
            rows={5}
          />
        </div>

        <Button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? '⏳ Enviando...' : '✨ Enviar mensaje'}
        </Button>
        
        <p className="form-note">
          {settings.form_note}
        </p>
      </form>
    </div>
  );
};

export default GuestbookForm;
